export default {
	ORDER: 'order',
};
